export enum BROADCAST_CHANNEL_TYPES {
  SIGN_OUT = 'SIGN_OUT',
  CLOSED_TAB = 'CLOSED_TAB',
  SIGN_IN = 'SIGN_IN'
}
